import React, { useState } from "react";
import { Divider, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "@common/components/Button";
import Typography from "@common/components/Typography";
import DialogAlert from "@common/components/DialogAlert";
import { DeviceCatalogMetadata } from "@services/catalog/types";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { displayDate } from "@common/utils/localTime.utils";
interface DeviceTopBannerProps {
  isLoading: boolean;
  metaData: DeviceCatalogMetadata | undefined;
  isPolling: boolean;
}

const DeviceTopBanner = (props: DeviceTopBannerProps) => {
  const { t } = useTranslation();
  const [openPopover, setOpenPopover] = useState<boolean>(false);
  const { isLoading, metaData, isPolling } = props;

  const renderDialog = () => (
    <DialogAlert
      open={openPopover}
      onClose={() => setOpenPopover(false)}
      title={t("What's new ?")}
      message={metaData?.releaseNotes ?? ""}
      severity="info"
      closeButtonLabel="OK"
    />
  );

  const renderImportStatus = (
    metaData: DeviceCatalogMetadata | undefined,
    isPolling: boolean
  ) => {
    if (isPolling) {
      if (
        metaData?.importStatus &&
        !metaData?.importStatus.toLowerCase().startsWith("failed")
      ) {
        return (
          <>
            <CloudUploadOutlinedIcon sx={{ mr: "1rem" }} />
            <Typography size="small" sx={{ mr: "1rem" }}>{`${t(
              "Import Status"
            )}: ${metaData?.importStatus}`}</Typography>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ marginRight: "1rem" }}
            />
          </>
        );
      }
    }
    return <></>;
  };

  return (
    <>
      {renderDialog()}
      {isLoading ? (
        <></>
      ) : (
        <Stack direction="row" sx={{
          alignItems: "center"
        }}>
          {metaData?.importStatus && renderImportStatus(metaData, isPolling)}
          <Typography size="small" sx={{ mr: "1rem" }}>
            {t("Catalog version : {{version}}", {
              version: metaData?.version ?? "",
            })}
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ marginRight: "1rem" }}
          />
          <Typography size="small" sx={{ mr: "1rem" }}>
            {t("Date : {{date}}", {
              date: displayDate(metaData?.datePublished),
            })}
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ marginRight: "1rem" }}
          />
          <Button variant="outlined" onClick={() => setOpenPopover(true)}>
            What's new ?
          </Button>
        </Stack>
      )}
    </>
  );
};

export default DeviceTopBanner;
